import { createFileRoute } from '@tanstack/react-router';

import { SignInScreen } from '@/auth/SignInScreen';

/**
 * Thin route-file shell. The screen component lives at
 * `src/auth/sign-in-screen.tsx`; this file's only job is to register
 * that screen against the `/sign-in` path.
 *
 * See `apps/client/docs/design.md` §"Route files are thin shells" for
 * the convention.
 */

export const Route = createFileRoute('/sign-in')({
  component: SignInScreen,
});
